// Токен Google reCAPTCHA v3 для отправки формы.
//
// Ключ сайта приходит с сервера в window.Application.config.recaptcha_site_key и
// пуст на доменах, где капча выключена (локальная разработка, тестовые домены) —
// тогда токен не запрашивается и форма отправляется как раньше.
//
// Скрипт Google подгружается лениво, при первой отправке формы, чтобы не тянуть
// его на страницах, где формы так и не тронули.

const SCRIPT_URL = "https://www.google.com/recaptcha/api.js?render=";

// Действие, под которым запрашивается токен. Сверяется на сервере
// (см. Recaptcha::ACTION) — менять только вместе с ним.
const ACTION = "submit";

let scriptPromise = null;

function getSiteKey() {
    return window.Application?.config?.recaptcha_site_key || "";
}

function loadScript(siteKey) {
    if (scriptPromise) {
        return scriptPromise;
    }

    scriptPromise = new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = SCRIPT_URL + encodeURIComponent(siteKey);
        script.async = true;
        script.onload = resolve;
        script.onerror = () => reject(new Error("Не удалось загрузить скрипт reCAPTCHA"));
        document.head.appendChild(script);
    });

    return scriptPromise;
}

/**
 * Возвращает токен reCAPTCHA либо null, если капча выключена или скрипт Google
 * не загрузился. На домене с включённой капчей заявку без токена сервер отклонит:
 * иначе обойти проверку можно было бы, просто не загрузив скрипт.
 * @returns {Promise<string|null>}
 */
export default async function recaptchaToken() {
    const siteKey = getSiteKey();

    if (!siteKey) {
        return null;
    }

    try {
        await loadScript(siteKey);
        await new Promise((resolve) => window.grecaptcha.ready(resolve));
        return await window.grecaptcha.execute(siteKey, { action: ACTION });
    } catch (err) {
        // Google недоступен (блокировки, сеть) — не срываем отправку формы.
        return null;
    }
}
